const EthereumEllipseIcon = /*#__PURE__*/ [
  ["path", { d: "M8 12L12 6L16 12M8 12L12 18L16 12M8 12L12 13.5L16 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "1" }]
];

export { EthereumEllipseIcon as default };
//# sourceMappingURL=EthereumEllipseIcon.js.map
